import NodeIndex from './data/NodeIndex'

class DocumentIndex extends NodeIndex {}

export default DocumentIndex
